
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certified-destruction",
      function () {
        return require("private-next-pages/certified-destruction/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certified-destruction"])
      });
    }
  